<template>
    <Videos />
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'
  import Videos from "@/views/video/Videos";
  export default {
    name: "Index",
    components: {Videos},
    data() {
      return {}
    },
    computed: {
      ...mapState(['myathletes', 'icons', 'sportcode', 'org']),
    },
    methods: {
      ...mapActions(['get', 'post']),
    }
  }
</script>

<style scoped>

</style>